import { GzSingleSelectComplexBaseDataProvider } from '../GzSingleSelectComplexBaseDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../../utils/request';
import { DEFAULT_DATA_LIMIT, GetItemsRequest, GetItemsResponse } from '../../types';
import { CompanyMethod } from '../../../../networkV2/networkAppContainer/helpers/types';

export class CompaniesFilterDataProvider extends GzSingleSelectComplexBaseDataProvider {
  // This is true because we send countRecords as false in the request, for MDR users
  shouldWorkWithoutTotalCount = true;

  static async getCompanyNameById(companyId: string): Promise<string> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'Company',
        method: CompanyMethod.GET_COMPANY_BY_ID,
        payload: {
          companyId: companyId,
        },
      });

      if (!response.success || !response.data.name) {
        throw new Error('Unable to get company name for filter');
      }

      return response.data.name;
    } catch (e) {
      throw new Error(e);
    }
  }

  async getInitialItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'Company',
        method: CompanyMethod.GET_AVAILABLE_COMPANIES,
        payload: {
          limit: request.limit || DEFAULT_DATA_LIMIT,
          options: {
            countRecords: false,
          },
        },
      });

      // If the required company value is not in the list, add it
      if (request.value && !response.data.find(({ _id }) => _id === request.value)) {
        try {
          const companyName = await CompaniesFilterDataProvider.getCompanyNameById(request.value as string);

          response.data.push({
            _id: request.value,
            name: companyName,
          });
        } catch (e) {
          // Do nothing, if this happens it means the user doesn't have access to the company previously set in filter
        }
      }

      return {
        items: response.data.map(({ _id, name }) => ({ value: _id, label: name })),
        totalItemsCount: response.count,
      };
    } catch (e) {
      throw new Error(e);
    }
  }
  async getItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'Company',
        method: CompanyMethod.GET_AVAILABLE_COMPANIES,
        payload: {
          page: request.page,
          limit: request.limit,
          companyName: request.searchValue,
          options: {
            countRecords: false,
          },
        },
      });

      return {
        items: response.data ? response.data.map(({ _id, name }) => ({ value: _id, label: name })) : [],
        totalItemsCount: response.count,
      };
    } catch (e) {
      throw new Error(e);
    }
  }
}
